import { QuestionService } from './../question.service';
import { Component, OnInit, Inject, NgZone, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { papers, topics } from '../static'
import { Injectable } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { UserServiceService } from '../user-service.service';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);

@Pipe({ name: 'safe' })

export class SafePipe implements PipeTransform {
  private chart: am4charts.XYChart;

  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
@Component({
  selector: 'app-mc-paper',
  templateUrl: './mc-paper.component.html',
  styleUrls: ['./mc-paper.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class McPaperComponent implements OnInit {
  private chart: am4charts.XYChart;
  loading = false;
  papers = papers;
  topics = topics;
  paper;
  questions;
  no_of_questions = 0;
  x;
  type;
  title;
  exam;
  paperID;
  answers = {};
  lang = 'E';
  sort = 'year';
  instant = false;
  loaded = false;
  score = 0;
  submitted = false;
  time;
  tag;
  started = false;
  constructor(
    private route: ActivatedRoute,
    private QuestionService: QuestionService,
    public dialog: MatDialog,
    public user: UserServiceService,
    private _snackBar: MatSnackBar,
    private zone: NgZone
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      clearInterval(this.x);
      Object.assign(this, {
        no_of_questions: 0,
        loaded: false,
        answer: {},
        sort: 'year',
        exam: params.get('exam'),
        type: params.get('type'),
        paperID: params.get('paperId')
      });

      if (this.type == 'year') {
        this.title = this.papers.find(x => x.id == params.get('paperId')).name;
        this.tag = this.title;

      } else if (this.type == 'topic') {
        this.title = this.topics.find(x => x.tag == params.get('paperId')).name;
        this.tag = this.paperID;

      }

      Object.assign(this, {
        questions: this.QuestionService.getQuestion(this.paperID, 'year', this.type, this.exam),
        answers: {},
        instant: false,
        loaded: false,
        score: 0,
        submitted: false,
        started: false,
      })

      this.questions.subscribe(result => {
        console.log(result.length);
        this.no_of_questions = result.length;
        this.timer();

        console.log('time' + this.time);

      });

      // console.log((this.questions));
    });



  }


  loadChart(all_school) {
    try {
      this.chart.dispose();
    }
    catch {
      console.log("Can't dispose!")
    }
    finally {

      console.log("Loading chart...")
      this.loading = true;
      this.zone.runOutsideAngular(() => {
        var xhr = new XMLHttpRequest();

        if (all_school == true) {
          xhr.open('GET', 'https://api.studydse.net/api/get_mc_answer_chart.php?school=all&type=' + this.exam + '&tag=' + this.tag);
        } else {
          xhr.open('GET', 'https://api.studydse.net/api/get_mc_answer_chart.php?type=' + this.exam + '&tag=' + this.tag);
        }

        // xhr.open('GET', '/assets/chart.json');
        xhr.withCredentials = true;
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = () => {
          let data = JSON.parse(xhr.responseText);

          var chart = am4core.create("chartContainer", am4charts.XYChart);

          var title = chart.titles.push(new am4core.Label());
          if (all_school == true) {
            title.text = "Performance of all schools";
          } else {
            title.text = "Performance of your school";
          }

          title.fontSize = 25;
          title.marginBottom = 25;
          // Add data
          chart.data = data;

          // Create axes
          var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
          categoryAxis.dataFields.category = "score";
          categoryAxis.title.text = "Score";
          categoryAxis.renderer.grid.template.location = 0;
          categoryAxis.renderer.minGridDistance = 20;
          categoryAxis.renderer.cellStartLocation = 0.1;
          categoryAxis.renderer.cellEndLocation = 0.9;

          var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
          valueAxis.min = 0;
          valueAxis.title.text = "No. of Students";

          // Create series
          function createSeries(field, name, stacked) {
            var series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = field;
            series.dataFields.categoryX = "score";
            series.name = name;
            series.columns.template.tooltipText = "{name}: [bold]{valueY}[/]";
            series.stacked = stacked;
            series.columns.template.width = am4core.percent(95);

          }

          createSeries("2020", "DSE2020", true);
          createSeries("2021", "DSE2021", true);
          createSeries("2022", "DSE2022", true);

          // Add legend
          chart.legend = new am4charts.Legend();
          chart.legend.position = "top";
          chart.scrollbarX = new am4core.Scrollbar();

          this.chart = chart;
          this.loading = false;
        };
        xhr.send();




      });

    }
  }
  ngDoCheck() {
    this.loaded = true;
  }
  getQuestion(sort) {
    this.sort = sort;
    this.questions = this.QuestionService.getQuestion(this.paperID, sort, this.type, this.exam);


  }

  setLang(lang) { this.lang = lang; }

  updateComment(qid, comment) {
    console.log({ qid, comment });

  }
  openAnswerDialog(question, lang) {
    console.log({ question, lang });
    this.dialog.open(AnswerDialog, {
      data: { question: question, lang: lang },
    });

  }

  openYoutubeDialog(question) {
    this.dialog.open(YoutubeDialog, {
      data: { youtube: "https://www.youtube-nocookie.com/embed/" + question.youtube },
    });

  }

  checkAns(question, ans) {
    this.started = true;
    if (question.ans == ans && this.answers[question.question_id] != ans) {
      this.score = this.score + 1;
    } else if (question.ans != ans && this.answers[question.question_id] == question.ans) {
      this.score = this.score - 1;
    }
    this.answers[question.question_id] = ans;
    let json = JSON.stringify(this.answers);
    console.log({ json });
    console.log(this.answers);
    console.log(this.score);

  }

  submitMC() {
    this.QuestionService.submitMC(JSON.stringify(this.answers), this.score, this.no_of_questions, this.tag, this.exam, this.time);
    this.submitted = true;
    this.instant = true;
    clearInterval(this.x);
  }

  timer() {

    // Set the date we're counting down to
    var countDownDate = new Date().getTime();
    console.log('Question' + this.no_of_questions);
    countDownDate = countDownDate + this.no_of_questions * 1000 * 60;

    // Update the count down every 1 second
    this.x = setInterval(() => {

      // Get todays date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds

      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      var hours = Math.floor((distance % (1000 * 60 * 60 * 60)) / (1000 * 60 * 60));

      // Output the result in an element with id="demo"
      this.time = "Remaining Time: " + hours + "h " + minutes + "m " + seconds + "s";


      // If the count down is over, write some text 
      if (distance < 0) {

        // Find the distance between now and the count down date
        var n_distance = 0 - distance;

        // Time calculations for days, hours, minutes and seconds

        var n_minutes = Math.floor((n_distance % (1000 * 60 * 60)) / (1000 * 60));
        var n_seconds = Math.floor((n_distance % (1000 * 60)) / 1000);

        this.time = "Overtime: " + n_minutes + "m " + n_seconds + "s";


      }

    }, 1000);

  }

  ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
      }

    });
  }
}

@Component({
  selector: 'answer-dialog',
  templateUrl: './answer-dialog.html',
})

export class AnswerDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data) { }


}


@Component({
  selector: 'youtube-dialog',
  templateUrl: './youtube-dialog.html',
})

export class YoutubeDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data) { }


}